export default "__VITE_ASSET__BYF23krb__"